import { Errors } from 'redesign/constants'
import { maxBirthDateValidator } from 'utils'
import { string, object } from 'yup'

export const schemaValidationCipAndFap = object({
    cipAndFap: string().required(Errors.selfService.CIP_REQUIRED),
    password: string().required(Errors.selfService.PASSWORD_REQUIRED_CIP),
    birthDate: string()
        .required(Errors.selfService.BIRTHDATE)
        .min(10, 'Insira uma data válida')
        .max(10, 'Insira uma data válida')
        .test('birthDate', 'Data de nascimento inválida', (value: string | undefined): boolean => maxBirthDateValidator(value)),
})
